/**
 * Drag-to-scroll functionality for desktop devices
 * Enables click-and-drag horizontal scrolling on pricing grid
 */

/**
 * Initialize drag-to-scroll behavior on the pricing grid wrapper
 * Only activates on devices with mouse/trackpad (not touch-only devices)
 */
export function initDragToScroll(): void {
  if (!window.matchMedia("(hover: hover)").matches) {
    return;
  }

  const wrapper = document.querySelector(
    ".mobile_table_wrapper",
  ) as HTMLElement | null;
  if (!wrapper) return;

  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;

  wrapper.addEventListener("mousedown", function (e: MouseEvent) {
    const target = e.target as HTMLElement;
    const tagName = target.tagName.toLowerCase();

    if (
      tagName === "input" ||
      tagName === "button" ||
      tagName === "select" ||
      tagName === "a"
    ) {
      return;
    }

    isDown = true;
    wrapper.classList.add("dragging");
    startX = e.pageX - wrapper.offsetLeft;
    scrollLeft = wrapper.scrollLeft;
  });

  wrapper.addEventListener("mouseleave", function () {
    isDown = false;
    wrapper.classList.remove("dragging");
  });

  wrapper.addEventListener("mouseup", function () {
    isDown = false;
    wrapper.classList.remove("dragging");
  });

  wrapper.addEventListener("mousemove", function (e: MouseEvent) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - wrapper.offsetLeft;
    const walk = (x - startX) * 1.5;
    wrapper.scrollLeft = scrollLeft - walk;
  });
}
